import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { IAPISubscriptionActivityGraphDataModel, IAPISubscriptionsActivityModel } from "../interfaces";

 
export class SubscriptionActivityModel {
    total: number;
    totalAmount: number;
    totalPastDue: number;
    graphData: SubscriptionActivityDataModel[];
    constructor(data?: Partial<SubscriptionActivityModel>) {
        this.total = data?.total || 0;
        this.totalAmount = data?.totalAmount || 0;
        this.totalPastDue = data?.totalPastDue || 0;
        this.graphData = data?.graphData?.map((s) => new SubscriptionActivityDataModel(s)) || [];
    }

    static deserializeAPIModel(data: IAPISubscriptionsActivityModel): SubscriptionActivityModel {
        const mappedData: Partial<SubscriptionActivityModel> = {
            total: data.total,
            totalAmount: data.totalAmount,
            totalPastDue: data.totalPastDue,
            graphData: data.graphData?.map((s) => SubscriptionActivityDataModel.deserializeAPIModel(s)) || [],
        };
        return new SubscriptionActivityModel(mappedData);
    }
}
export class SubscriptionActivityDataModel {
    date: Date;
    total: number;
    label: string;
    constructor(data?: Partial<SubscriptionActivityDataModel>) {
        this.date = new Date(data?.date || '');
        this.total = data?.total || 0;
        this.label = UtilityMethods.formatDateInMonthAndDay(this.date);
    }

    static deserializeAPIModel(data: IAPISubscriptionActivityGraphDataModel): SubscriptionActivityDataModel {
        const mappedData: Partial<SubscriptionActivityDataModel> = {
            date: UtilityMethods.removeZFromDateString(data.date),
            total: data.total,
        };
        return new SubscriptionActivityDataModel(mappedData);
    }
}
